__turbopack_context__.v({
  "requiredLevel": "vods-module__O9ze4G__requiredLevel",
  "restricted": "vods-module__O9ze4G__restricted",
  "search": "vods-module__O9ze4G__search",
  "vod": "vods-module__O9ze4G__vod",
  "vodPlaying": "vods-module__O9ze4G__vodPlaying",
});
